<template>
	<div>
		<span
			class="badge badge-secondary badge-sm mr-2 mb-2"
			v-for="(tag, index) in tags"
			v-bind:key="index"
		>
			{{ tag.name }}
		</span>
	</div>
</template>

<script>
export default {
	props: {
		tags: []
	},
	data() {
		return {
		};
	},
	methods: {
	},
	computed: {
	},
};
</script>
